<template>
<div></div>
</template>

<script>
export default {
  name: 'PageTitle'
}
</script>

<style scoped>

</style>
